import { makeRESTApiRequest } from './api';
import { ADMIN_ROLE, BILLING_NOTE_ALLOWED_ORDER_STATUSES, ENDPOINTS } from './constants';

export const COMPLETED_ORDER_STATUSES = ['Pending To Pay', 'Paid'];

export const ORDER_NOTE_SOURCE = 'Order Detail';

export const isCompletedOrderStatus = status => COMPLETED_ORDER_STATUSES.includes(status);

export const showsBillingNotesSection = status => BILLING_NOTE_ALLOWED_ORDER_STATUSES.includes(status);

export const getAuthorInitials = (name = '') => {
  const parts = String(name).trim().split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
  }
  if (parts.length === 1) {
    return parts[0].slice(0, 2).toUpperCase();
  }
  return '?';
};

export const fetchComments = async (orderId, { signal } = {}) => {
  return makeRESTApiRequest({
    endpoint: `${ENDPOINTS.COMMENTS}?orderId=${orderId}`,
    method: 'GET',
    signal
  });
};

export const createComment = async ({ orderId, text, source = ORDER_NOTE_SOURCE }) => {
  return makeRESTApiRequest({
    endpoint: ENDPOINTS.COMMENTS,
    method: 'POST',
    requestBody: { orderId, text, source }
  });
};

export const updateComment = async (commentId, text) => {
  return makeRESTApiRequest({
    endpoint: ENDPOINTS.COMMENT_WITH_ID(commentId),
    method: 'PUT',
    requestBody: { text }
  });
};

export const deleteComment = async commentId => {
  return makeRESTApiRequest({
    endpoint: ENDPOINTS.COMMENT_WITH_ID(commentId),
    method: 'DELETE'
  });
};

export const fetchBillingNotes = async (orderId, { signal, viewAsOrganizationId } = {}) => {
  const params = new URLSearchParams({ orderId });
  if (viewAsOrganizationId) {
    params.set('viewAsOrganizationId', viewAsOrganizationId);
  }
  return makeRESTApiRequest({
    endpoint: `${ENDPOINTS.BILLING_NOTES}?${params.toString()}`,
    method: 'GET',
    signal
  });
};

export const createBillingNote = async ({
  orderId,
  text,
  source = ORDER_NOTE_SOURCE,
  viewAsOrganizationId
}) => {
  return makeRESTApiRequest({
    endpoint: ENDPOINTS.BILLING_NOTES,
    method: 'POST',
    requestBody: {
      orderId,
      text,
      source,
      ...(viewAsOrganizationId ? { viewAsOrganizationId } : {})
    }
  });
};

export const updateBillingNote = async (billingNoteId, text) => {
  return makeRESTApiRequest({
    endpoint: ENDPOINTS.BILLING_NOTE_WITH_ID(billingNoteId),
    method: 'PUT',
    requestBody: { text }
  });
};

export const deleteBillingNote = async billingNoteId => {
  return makeRESTApiRequest({
    endpoint: ENDPOINTS.BILLING_NOTE_WITH_ID(billingNoteId),
    method: 'DELETE'
  });
};

export const isNoteAuthor = (item, currentUser) => {
  if (!item?.author || !currentUser) return false;
  if (currentUser.role === ADMIN_ROLE) return true;

  const author = String(item.author).trim().toLowerCase();
  const identifiers = [currentUser?.name, currentUser?.email]
    .filter(Boolean)
    .map(value => String(value).trim().toLowerCase());

  return identifiers.includes(author);
};
